import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import API_BASE_URL from "../../../../Constants";
import { useAuth } from "../../../../contexts/AuthContext";

const EditCallCenterForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [formData, setFormData] = useState({
    dispatchNumber: "",
    buildingSite: "",
    deviceId: "",
    customerNumber: "",
    dispatchType: "",
    mechanics: "",
    actualHours: "",
    regHours: "",
  });


  const { user } = useAuth();
  const [notifications, setNotifications] = useState([]);
  const [eventSRC, setEventSRC] = useState(null);

  useEffect(() => {
    const eventSource = new EventSource(`${API_BASE_URL}/sse/subscribe?username=${encodeURIComponent(user.username)}`);
    setEventSRC(eventSource);

    eventSource.onmessage = (event) => {
      alert(event.data);
      setNotifications((prevNotifications) => [...prevNotifications, event.data]);
    };

    eventSource.onerror = (err) => {
      console.error('EventSource failed:', err);
      eventSource.close();
    };

    return () => {
      eventSource.close();
    };
  }, [user]);

  // componentUnmount useEffect
  useEffect(() => {
    return () => {
      if (eventSRC) {
        eventSRC.close();
      }
    };
  }, [eventSRC]);

  useEffect(() => {
    const fetchCallCenter = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/callcenter/callcenterlist/callcenters/${id}`, {
          credentials: 'include'
        });
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setFormData(data);
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };

    fetchCallCenter();
  }, [id]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      clearUserLocks(user.username);
      event.preventDefault();
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      clearUserLocks(user.username);
    };
  }, []);

  // API CALL TO NOTIFY REQUESTERS
  const notifyRequesters = async (recordId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/notify/requesters?recordId=${encodeURIComponent(recordId + "callcenterlist")}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });

      if (response.ok) {
        const message = await response.text();
        console.log('Server response:', message);
      } else {
        throw new Error('Failed to notify requesters');
      }
    } catch (error) {
      console.error('An error occurred:', error.message);
    }
  };

  const clearUserLocks = async (username) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/record/${encodeURIComponent(username)}/clear-locks`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include'
      });

      if (response.ok) {
        const message = await response.text();
        console.log('Server response:', message);
        notifyRequesters(id);
      } else {
        throw new Error('Failed to clear locks');
      }
    } catch (error) {
      console.error('An error occurred:', error.message);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/callcenter/callcenterlist/callcenters/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
          credentials: "include",
        }
      );

      if (response.ok) {
        alert("Call center edited successfully");
        clearUserLocks(user.username);
        navigate("/call-center/callcenterlist");
      } else {
        throw new Error("Failed to edit call center");
      }
    } catch (error) {
      console.error("Error editing call center:", error);
      alert("An error occurred while editing call center");
    }
  };

  return (
    <div className="max-w-sm mx-auto mt-10 p-6 gradient-bg rounded-xl shadow-lg">
      <h2 className="text-2xl font-bold mb-6 text-left text-white">
        Edit Call Center
      </h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-gray-100">Dispatch Number:</label>
          <input
            type="text"
            name="dispatchNumber"
            value={formData.dispatchNumber}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border rounded-md"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-100">Building Site:</label>
          <input
            type="text"
            name="buildingSite"
            value={formData.buildingSite}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border rounded-md"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-100">Device Id:</label>
          <input
            type="text"
            name="deviceId"
            value={formData.deviceId}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border rounded-md"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-100">Customer Number:</label>
          <input
            type="text"
            name="customerNumber"
            value={formData.customerNumber}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border rounded-md"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-100">Dispatch Type:</label>
          <input
            type="text"
            name="dispatchType"
            value={formData.dispatchType}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border rounded-md"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-100">Mechanics:</label>
          <input
            type="text"
            name="mechanics"
            value={formData.mechanics}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border rounded-md"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-100">Actual Hours:</label>
          <input
            type="text"
            name="actualHours"
            value={formData.actualHours}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border rounded-md"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-100">Reg Hours:</label>
          <input
            type="text"
            name="regHours"
            value={formData.regHours}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border rounded-md"
          />
        </div>
        <button
          type="submit"
          className="w-full py-2 px-4 bg-blue-500 text-white font-semibold rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
        >
          Edit Call Center
        </button>
      </form>
    </div>
  );
};

export default EditCallCenterForm;
